import React, { useState, useEffect } from 'react'
import ColorButton from '../Buttons/ColorButton'
import apptheme from '../theme/default'
import { Box } from '@mui/material'

import ReplyIcon from '@mui/icons-material/Reply';
import PrintIcon from '@mui/icons-material/Print';
import AlignVerticalBottomIcon from '@mui/icons-material/AlignVerticalBottom';
import DefButton from '../Buttons/defbutton'
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import { useWindowSize } from "@uidotdev/usehooks";
import { hasPermissions } from '../Utils/groups'
import GerenciarTabela from './gerenciarTabela'
import ImpressaoTabela from './impressaoTabela';
import Distribution from '../Distribuicao';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SubmenuCard from '../Utils/submenuCard';
import RotasRegioes from '../Frete/rotasRegioes';
import Transportadoras from '../Frete/transportadoras';
import IndexConhecimentos from '../Frete/indexConhecimentos';


const CalcWidthSize = (size) => {
    const threshold = size?.width < 768 ? 200 : 400
    const calcSize = Math.round(size?.width / threshold)
    if (!calcSize)
        return 2
    return calcSize
}

const MenuList = () => ({

    'distribuicao': {
        title: 'Distribuição',
        icon: (<AlignVerticalBottomIcon />),
        obj: (<Distribution />),
        permission: (hasPermissions('administrador', 'grupo_administradores'))
    },
    'gerenciartabela': {
        title: 'Gerenciar Tabela',
        icon: (<LocalAtmIcon />),
        obj: (<GerenciarTabela />),
        permission: (hasPermissions('administrador', 'grupo_administradores'))
    },
    'impressaotabela': {
        title: 'Impressão Tabela',
        icon: (<PrintIcon />),
        obj: (<ImpressaoTabela />),
        permission: (hasPermissions('administrador', 'grupo_administradores', 'representante', 'funcRepresentante', 'admfilial'))
    },
    'frete': {
        title: 'Frete',
        icon: (<LocalShippingIcon />),
        obj: (<></>),
        permission: (hasPermissions('administrador', 'grupo_administradores', 'admfilial')),
        submenu: true,
        submenuList: {
            'rotas_regioes': { title: 'Rotas/Regiões', obj: (<RotasRegioes />) },
            'transportadora': { title: 'Cadastro de Transportadora', obj: (<Transportadoras />) },
            'gestao_de_fretes': { title: 'Gestão de Fretes', obj: (<IndexConhecimentos />) }
        }
    },

})

const Comercial = () => {
    const [selectedTab, setSelectedTab] = useState(null)
    const [selectedSubmenu, setSelectedSubmenu] = useState(null)
    const size = useWindowSize();
    const menulist = MenuList()

    const calcSize = CalcWidthSize(size)

    const itens = Object.entries(menulist).filter(([key, value]) => value.permission)

    useEffect(() => {
        window.backtobase = () => setSelectedTab(null)
    }, [])

    return (
        <>
            {selectedTab === null ? (
                <Box className='gridBox' sx={{ gridTemplateColumns: `repeat(${calcSize}, minMax(0, 1fr))` }}>
                    {itens.map(([key, value]) => (
                        <React.Fragment key={key}>
                            {!value.submenu ? (
                                <ColorButton
                                    onClick={() => setSelectedTab(key)}
                                    sx={{ height: '8rem', flex: 1, visibility: !value.obj ? 'hidden' : 'visible' }}
                                    fColor={apptheme.primaryColor}
                                    sColor={apptheme.tertiaryColor}
                                >
                                    <Box className='flexbox'>
                                        {value.icon}
                                        {value.title}
                                    </Box>
                                </ColorButton>
                            ) : (
                                <SubmenuCard value={value} cardName={key} setSelectedTab={setSelectedTab} setSelectedSubmenu={setSelectedSubmenu} />
                            )}
                        </React.Fragment>
                    ))}
                </Box>
            ) : (
                <>
                    <Box className='settings-back-button'>
                        <DefButton onClick={() => { setSelectedTab(null); setSelectedSubmenu(null) }}>
                            <ReplyIcon />
                        </DefButton>
                    </Box>

                    {selectedSubmenu && menulist[selectedTab]?.submenuList
                        ? menulist[selectedTab].submenuList[selectedSubmenu]?.obj
                        : menulist[selectedTab]?.obj}
                </>
            )}

        </>
    )
}

export default Comercial